export default __webpack_public_path__ + "static/media/menupl-sm-light.d553b8f2.svg";